<template>
  <div class="translate-office-page">
    <!-- Hero Section -->
    <OfficeHeroSection />

    <!-- Translation Form Section -->
    <section class="translation-form-section">
      <div class="container">
        <CategoryTranslationForm
          category="office"
          @start-translation="handleStartTranslation"
        />
      </div>
    </section>

    <!-- SEO Content Sections -->
    <section class="seo-content">
      <div class="container">
        <!-- Service Advantages -->
        <div class="advantages-section">
          <h2>{{ $t('category.office.advantages.title') }}</h2>
          <div class="advantages-grid">
            <div class="advantage-item">
              <Icon name="material-symbols:check-circle" class="advantage-icon" />
              <span>{{ $t('category.office.advantages.wordLayout') }}</span>
            </div>
            <div class="advantage-item">
              <Icon name="material-symbols:check-circle" class="advantage-icon" />
              <span>{{ $t('category.office.advantages.pptAnimation') }}</span>
            </div>
            <div class="advantage-item">
              <Icon name="material-symbols:check-circle" class="advantage-icon" />
              <span>{{ $t('category.office.advantages.excelFormula') }}</span>
            </div>
            <div class="advantage-item">
              <Icon name="material-symbols:check-circle" class="advantage-icon" />
              <span>{{ $t('category.common.features.languages') }}</span>
            </div>
          </div>
        </div>

        <!-- Format Cards -->
        <OfficeFormatCards />

        <!-- Scenarios -->
        <OfficeScenarios />

        <!-- FAQ -->
        <OfficeFAQ />
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
// Page meta information for SEO
const { t } = useI18n()
useWebsiteSeo({
  title: () => t('seo.category.office.title'),
  description: () => t('seo.category.office.desc')
})

// 组件导入
import CategoryTranslationForm from '~/components/shared/CategoryTranslationForm.vue'

// 事件处理（第一阶段静态展示）
const handleStartTranslation = (settings: any) => {
  console.log('Office翻译页面 - 开始翻译:', settings)
  // 第一阶段仅做静态展示，暂时只输出日志
}
</script>

<style scoped>
.translate-office-page {
  min-height: 100vh;
}

.translation-form-section {
  padding: 2rem 0;
  background: #f8f9fa;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}

.seo-content {
  padding: 4rem 0;
}

.advantages-section {
  margin-bottom: 4rem;
}

.advantages-section h2 {
  text-align: center;
  font-size: 2rem;
  color: #2c3e50;
  margin-bottom: 2rem;
}

.advantages-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
  margin-top: 2rem;
}

.advantage-item {
  display: flex;
  align-items: center;
  padding: 1rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;
}

.advantage-item:hover {
  transform: translateY(-2px);
}

.advantage-icon {
  color: #4A90E2;
  font-size: 1.5rem;
  margin-right: 1rem;
  flex-shrink: 0;
}

@media (max-width: 768px) {
  .advantages-grid {
    grid-template-columns: 1fr;
  }
}
</style>
